import { render } from "./component.vue?vue&type=template&id=43c4531d&ts=true"
import script from "./component.ts?vue&type=script&lang=ts&external"
export * from "./component.ts?vue&type=script&lang=ts&external"

import "./component.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__